import React from "react";

/**
 * Function for rendering a booked icon.
 *
 * @param {string} cls - class name for styling the icon
 * @return {JSX.Element} SVG icon component
 */
export const BookedIcon = ({ cls = "" }) => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        d="M25.8333 2.66667H24.5V1.33333C24.5 0.597333 23.904 0 23.1667 0C22.4293 0 21.8333 0.597333 21.8333 1.33333V2.66667H11.1667V1.33333C11.1667 0.597333 10.5707 0 9.83333 0C9.096 0 8.5 0.597333 8.5 1.33333V2.66667H7.16667C3.49067 2.66667 0.5 5.65733 0.5 9.33333V25.3333C0.5 29.0093 3.49067 32 7.16667 32H25.8333C29.5093 32 32.5 29.0093 32.5 25.3333V9.33333C32.5 5.65733 29.5093 2.66667 25.8333 2.66667ZM7.16667 5.33333H25.8333C28.0387 5.33333 29.8333 7.128 29.8333 9.33333V10.6667H3.16667V9.33333C3.16667 7.128 4.96133 5.33333 7.16667 5.33333ZM25.8333 29.3333H7.16667C4.96133 29.3333 3.16667 27.5387 3.16667 25.3333V13.3333H29.8333V25.3333C29.8333 27.5387 28.0387 29.3333 25.8333 29.3333ZM24.276 17.536C24.788 18.0653 24.772 18.9107 24.2427 19.4213L17.9227 25.512C17.1853 26.2493 16.18 26.6667 15.112 26.6667C14.044 26.6667 13.0387 26.2507 12.284 25.4947L9.28133 22.7053C8.74267 22.204 8.71067 21.36 9.212 20.8213C9.716 20.2813 10.5587 20.252 11.096 20.752L14.1333 23.5747C14.7107 24.148 15.5507 24.1107 16.052 23.6093L22.3907 17.5C22.9213 16.9893 23.764 17.0053 24.276 17.5347V17.536Z"
        fill="currentColor"
      />
    </svg>
  );
};
